import { getBaseUrl } from '@/utils/urlHelpers'
import { IconNames } from 'lib/settings/icons'

export interface OrderTrackingButtonItem {
  id: string
  icon?: string
  path?: string
  text: string
  className?: string
  loggedInOnly: boolean
  hideForGuest?: boolean
  modal?: boolean
  targetModal?: string
  onClick?: (orderId: string) => void
}

const orderTrackingButtons: OrderTrackingButtonItem[] = [
  {
    id: 'edit-order',
    icon: 'edit',
    text: 'Edit order',
    loggedInOnly: true,
    hideForGuest: true,
    onClick: (orderId: string) => {
      window.open(`${getBaseUrl()}/orders/${orderId}/edit`, '_blank')
    },
  },
  {
    id: 'share-itinerary',
    icon: 'share',
    text: 'Share itinerary',
    loggedInOnly: true,
    modal: true,
    targetModal: 'share-itinerary-modal',
  },
  {
    id: 'print-receipt',
    icon: 'receipt',
    path: 'payments/print_receipt?order_id={order_id}',
    text: 'Print receipt',
    loggedInOnly: true,
    onClick: (orderId: string) => {
      window.open(
        `${getBaseUrl()}/payments/print_receipt?order_id=${orderId}`,
        '_blank',
      )
    },
  },
  {
    id: 'print-all-labels',
    text: 'Print all labels',
    icon: 'print' as IconNames,
    modal: true,
    targetModal: 'print-labels-modal',
    loggedInOnly: false,
  },
]

export default orderTrackingButtons
